import {Component, Input, OnInit} from '@angular/core';
import {FormGroup} from "@angular/forms";
import {
  JaarrapportageEntity,
  ClientEntity,
} from "@snelstart-ventures/fiscaal/domain-logic";
import {BokkzAlgDataService, BokkzJrDataService} from "@snelstart-ventures/fiscaal/domain-logic";
import { SharedUiFormControlsModule } from '@snelstart/ui-form-controls';
import { SharedUiDetailsModule } from '@snelstart/ui-details';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-passiva',
  templateUrl: './passiva.component.html',
  imports: [
    SharedUiFormControlsModule,
    SharedUiDetailsModule
],
  styleUrls: ['./passiva.component.scss']
})
export class PassivaComponent implements OnInit {

  @Input() public id!: string;
  public taxPayer = {} as ClientEntity;
  public totalShareCapitalFg = {} as FormGroup;
  public totalSharePremiumFg = {} as FormGroup;
  public totalRevaluationReserveFg = {} as FormGroup;
  public totalLegalReservesFg = {} as FormGroup;
  public totalStatutoryReservesFg = {} as FormGroup;
  public totalReservesOtherFg = {} as FormGroup;
  public totalReinvestmentReserveFg = {} as FormGroup;
  public totalOtherFiscalReservesFg = {} as FormGroup;
  public totalResultForTheYearFg = {} as FormGroup;
  public totalRetainedEarningsFg = {} as FormGroup;
  public totalEquityFg = {} as FormGroup
  public totalNoncontrollingInterestFg = {} as FormGroup
  public totalEquityGroupFg = {} as FormGroup
  public totalVoorzFg = {} as FormGroup;
  public totalKortFg = {} as FormGroup;
  public totalLangFg = {} as FormGroup;
  public totalEquityAndLiabilitiesFg = {} as FormGroup;
  public jrEntity = {} as JaarrapportageEntity;
  public isRechtspersoon = false;
  public heeftAandelen = false;
  public isCooperatie= false;
  public isEnkelvoudig = false;
  public isFiscaleGrondslagen = false;
  public isMicro = false;
  public isKlein = false;
  public isBalansNaResultaatbestemming = false;
  public year: number | undefined = {} as number;

  constructor(
    public algDataService: BokkzAlgDataService,
    public jrDataService: BokkzJrDataService) {
    this.totalShareCapitalFg = this.jrDataService.createFormGroupBalanceItem();
    this.totalSharePremiumFg = this.jrDataService.createFormGroupBalanceItem();
    this.totalRevaluationReserveFg = this.jrDataService.createFormGroupBalanceItem();
    this.totalLegalReservesFg = this.jrDataService.createFormGroupBalanceItem();
    this.totalStatutoryReservesFg = this.jrDataService.createFormGroupBalanceItem();
    this.totalReservesOtherFg = this.jrDataService.createFormGroupBalanceItem();
    this.totalReinvestmentReserveFg = this.jrDataService.createFormGroupBalanceItem();
    this.totalOtherFiscalReservesFg = this.jrDataService.createFormGroupBalanceItem();
    this.totalResultForTheYearFg = this.jrDataService.createFormGroupBalanceItem();
    this.totalRetainedEarningsFg = this.jrDataService.createFormGroupBalanceItem();
    this.totalEquityFg = this.jrDataService.createFormGroupBalanceItem();
    this.totalNoncontrollingInterestFg = this.jrDataService.createFormGroupBalanceItem();
    this.totalEquityGroupFg = this.jrDataService.createFormGroupBalanceItem();
    this.totalVoorzFg = this.jrDataService.createFormGroupBalanceItem();
    this.totalKortFg = this.jrDataService.createFormGroupBalanceItem();
    this.totalLangFg = this.jrDataService.createFormGroupBalanceItem();
    this.totalEquityAndLiabilitiesFg = this.jrDataService.createFormGroupBalanceItem();
  }

  ngOnInit(): void {
    this.algDataService.client.subscribe((value) => {
      this.taxPayer = value;
    });
    this.jrDataService.jaarrapportageEntity.subscribe((value) => {
      this.jrEntity = value;
      this.year = value.year;
      const balans = value.rapportage?.jaarrekeningen?.at(0)?.balans;
      if (balans) {
        if (balans.aandelenkapitaal?.shareCapitalPaidCalledUp) {
          this.totalShareCapitalFg.patchValue(balans.aandelenkapitaal.shareCapitalPaidCalledUp)
        }
        if (balans.agio?.sharePremium) {
          this.totalSharePremiumFg.patchValue(balans.agio.sharePremium)
        }
        if (balans.herwaarderingsreserve?.revaluationReserve) {
          this.totalRevaluationReserveFg.patchValue(balans.herwaarderingsreserve.revaluationReserve)
        }
        if (balans.andereWettelijkeReserves?.legalReserves) {
          this.totalLegalReservesFg.patchValue(balans.andereWettelijkeReserves.legalReserves)
        }
        if (balans.statutaireReserves?.statutoryReserves) {
          this.totalStatutoryReservesFg.patchValue(balans.statutaireReserves.statutoryReserves)
        }
        if (balans.herinvesteringsreserve?.reinvestmentReserve) {
          this.totalReinvestmentReserveFg.patchValue(balans.herinvesteringsreserve.reinvestmentReserve)
        }
        if (balans.overigeReserves?.reservesOther) {
          this.totalReservesOtherFg.patchValue(balans.overigeReserves.reservesOther)
        }
        if (balans.overigeFiscaleReserves?.otherFiscalReserves) {
          this.totalOtherFiscalReservesFg.patchValue(balans.overigeFiscaleReserves.otherFiscalReserves)
        }
        if (balans.resultaatBoekjaar?.resultForTheYear) {
          this.totalResultForTheYearFg.patchValue(balans.resultaatBoekjaar.resultForTheYear)
        }
        if (balans.nietVerdeeldeWinsten?.retainedEarnings) {
          this.totalRetainedEarningsFg.patchValue(balans.nietVerdeeldeWinsten.retainedEarnings)
        }
        if (balans.eigenVermogen?.equity) {
          this.totalEquityFg.patchValue(balans.eigenVermogen.equity)
        }
        if (balans.aandeelDerden?.noncontrollingInterest) {
          this.totalNoncontrollingInterestFg.patchValue(balans.aandeelDerden.noncontrollingInterest)
        }
        if (balans.groepsvermogen?.equityGroup) {
          this.totalEquityGroupFg.patchValue(balans.groepsvermogen.equityGroup)
        }
        if (balans.voorzieningen?.provisions) {
          this.totalVoorzFg.patchValue(balans.voorzieningen.provisions)
        }
        if (balans.langlopendeSchulden?.liabilitiesNoncurrent) {
          this.totalLangFg.patchValue(balans.langlopendeSchulden.liabilitiesNoncurrent)
        }
        if (balans.kortlopendeSchulden?.liabilitiesCurrent) {
          this.totalKortFg.patchValue(balans.kortlopendeSchulden.liabilitiesCurrent)
        }
        if (balans.passiva?.equityAndLiabilities) {
          this.totalEquityAndLiabilitiesFg.patchValue(balans.passiva.equityAndLiabilities)
        }
      }
    });
    this.jrDataService.isRechtspersoon.subscribe((value) => {
      this.isRechtspersoon = value;
    })
    this.jrDataService.heeftAandelen.subscribe((value) => {
      this.heeftAandelen = value;
    })
    this.jrDataService.isCooperatie.subscribe((value) => {
      this.isCooperatie = value;
    });
    this.jrDataService.isEnkelvoudig.subscribe((value) => {
      this.isEnkelvoudig = value;
    })
    this.jrDataService.isFiscaleGrondslagen.subscribe((value) => {
      this.isFiscaleGrondslagen = value;
    })
    this.jrDataService.isMicro.subscribe((value) => {
      this.isMicro = value;
    })
    this.jrDataService.isKlein.subscribe((value) => {
      this.isKlein = value;
    })
    this.jrDataService.isBalansNaResultaatbestemming.subscribe((value) => {
      this.isBalansNaResultaatbestemming = value;
    })
  }
}
